import { Component, Input, inject } from "@angular/core";
import { Roster } from "@app/models/rest/roster/roster";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Location } from "@angular/common";
import { RosterStore } from "@app/services/store/roster/roster-store";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { RosterService } from "@app/services/http/roster.service";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { MatIconAnchor } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import {
  MatTabGroup,
  MatTab,
  MatTabLabel,
  MatTabContent
} from "@angular/material/tabs";
import { DivisionGridComponent } from "../division-grid/division-grid.component";
import { AssignmentEditComponent } from "../assignment-edit/assignment-edit.component";
import { NonWorkingDayListComponent } from "../non-working-day-list/non-working-day-list.component";
import { RunHistoryViewGridComponent } from "../run-history-view-grid/run-history-view-grid.component";

@Component({
  selector: "app-roster-edit",
  templateUrl: "./roster-edit.component.html",
  styleUrls: ["./roster-edit.component.css"],
  imports: [
    MatToolbar,
    MatToolbarRow,
    MatIconAnchor,
    RouterLink,
    MatIcon,
    MatTabGroup,
    MatTab,
    MatTabLabel,
    MatTabContent,
    DivisionGridComponent,
    AssignmentEditComponent,
    NonWorkingDayListComponent,
    RunHistoryViewGridComponent
  ]
})
export class RosterEditComponent {
  rosterStore = inject(RosterStore);
  dialog = inject(MatDialog);
  private router = inject(Router);
  private activeRoute = inject(ActivatedRoute);
  serviceErrorHandler = inject(ServiceErrorHandlerService);
  private snackBar = inject(MatSnackBar);
  private ngxLoader = inject(NgxUiLoaderService);
  private rosterService = inject(RosterService);
  private location = inject(Location);

  currentLoadingMessage: string;
  roster: Roster;
  rosterForm = new UntypedFormGroup({
    name: new UntypedFormControl(""),
    length: new UntypedFormControl(""),
    startDate: new UntypedFormControl(""),
    endDate: new UntypedFormControl(""),
    generateDaysAhead: new UntypedFormControl("")
  });

  constructor() {
    this.activeRoute.params.subscribe((params) => {
      if (params && params["id"]) {
        this.rosterId = params["id"];
      }
    });
  }

  private _rosterId: number;

  get rosterId() {
    return this._rosterId;
  }

  @Input()
  set rosterId(value: number) {
    this._rosterId = value;
    this.loadRoster();
    // this.ngxLoader.startLoader('bookingLoader', 'confirm');
  }

  returnToList() {}

  onSubmit() {
    console.warn(this.rosterForm.value);
    Object.assign(this.roster, this.rosterForm.value);
    this.ngxLoader.startLoader("rosterLoader", "load");
    this.rosterStore.update(this.roster).subscribe((value) => {
      this.rosterForm.reset(this.roster);
      this.ngxLoader.stopLoader("rosterLoader", "load");
    });
  }

  reset() {
    this.rosterForm.reset(this.roster);
  }

  private loadRoster() {
    console.log("roster id changed to " + this.rosterId);
    this.ngxLoader.startLoader("rosterLoader", "load");
    this.rosterStore.loadSingle(this.rosterId).then((halRoster: Roster) => {
      this.roster = halRoster;
      this.ngxLoader.stopLoader("rosterLoader", "load");
      this.rosterForm.patchValue(this.roster);
    });
  }
}
